import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class SportTypeEmptyStateSportsImageRequestParams extends AssetsRequestParams {
  constructor(width: Number,height: Number, sportTypeId: Number) {
    super(width, height);

    this.resourceName = this.resourceName + '/EmptyState/SportTypesEmptyState/' + sportTypeId;
  }

  get params(): * {
    return `${super.params},d_Website:AssetsSVGNewBrand:EmptyState:SportTypesEmptyState:default.svg`;
  }
}
